import Move from './Move';
import Draw from './Draw';
import DrawRect from './DrawRect';
import DrawEllipse from './DrawEllipse';
import Ruler from './Ruler';
import DrawArrow from './arrow';

export default [
  Move,
  Draw,
  DrawRect,
  DrawEllipse,
  Ruler,
  DrawArrow
];